/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Youreventandimageshavebeenuploadedsuccessfully7Inputs */

const en_youreventandimageshavebeenuploadedsuccessfully7 = /** @type {(inputs: Youreventandimageshavebeenuploadedsuccessfully7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your event and images have been uploaded successfully.`)
};

const de_youreventandimageshavebeenuploadedsuccessfully7 = /** @type {(inputs: Youreventandimageshavebeenuploadedsuccessfully7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Event und die Bilder wurden hochgeladen.`)
};

/**
* | output |
* | --- |
* | "Your event and images have been uploaded successfully." |
*
* @param {Youreventandimageshavebeenuploadedsuccessfully7Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const youreventandimageshavebeenuploadedsuccessfully7 = /** @type {((inputs?: Youreventandimageshavebeenuploadedsuccessfully7Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Youreventandimageshavebeenuploadedsuccessfully7Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_youreventandimageshavebeenuploadedsuccessfully7(inputs)
	return de_youreventandimageshavebeenuploadedsuccessfully7(inputs)
});
export { youreventandimageshavebeenuploadedsuccessfully7 as "yourEventAndImagesHaveBeenUploadedSuccessfully" }